var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v(_vm._s(_vm.$copy.title))]),_c('Message',{attrs:{"mb":30}},[_vm._v(_vm._s(_vm.$copy.message))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }